import styled from 'styled-components';
import Grid from 'components/core/Grid';
import { Box, Typography } from '@mui/material';
import AppCard from 'components/core/AppCard/Card';

// Content Wrapper and overrides
export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  && h1 {
    font-size: 42px;
    font-weight: 600;
  }

  && h2 {
    font-size: 32px;
    font-weight: 600;
    color: ${props => props.theme.palette.primary.main};
  }

  && h3 {
    font-size: 24px;
    font-weight: 400;
  }

  & .add-image-shadow {
    filter: drop-shadow(0px 4px 6px #cccccc);
  }
`;

export const CircleBullet = styled.span`
  background-color: ${props => props.theme.palette.secondary.main};
  padding: 0 ${props => props.theme.spacing(1)};
  color: #fff;
  border-radius: 50%;
  margin-right: ${props => props.theme.spacing(1)};
`;

// Header Box
export const HeaderWrapper = styled(Grid)`
  width: 100%;
  max-width: ${props => props.theme.breakpoints.values.lg}px;
  padding: 0 ${props => props.theme.spacing(3)};
  padding-top: ${props => props.theme.spacing(2)};

  ${props => props.theme.breakpoints.down('md')} {
    padding: ${props => props.theme.spacing(1)};
    justify-content: center;
  }
`;

export const HeaderLogo = styled(Grid)`
  & img {
    height: 60px;
  }
  ${props => props.theme.breakpoints.down('md')} {
    text-align: center;
    width: 100%;
    height: auto;
  }
`;

export const HeaderLinks = styled(Grid)`
  display: flex;
  justify-content: flex-end;

  & .MuiButton-root:not(:first-child) {
    border-left: 1px solid #e7e7e7;
    padding-left: ${props => props.theme.spacing(2)};
  }

  & .MuiButton-root:not(:last-child) {
    padding-right: ${props => props.theme.spacing(2)};
  }

  ${props => props.theme.breakpoints.down('md')} {
    display: none;
  }
`;

export const AnimatedImageWrapper = styled(Grid)`
  position: relative;

  ${props => props.theme.breakpoints.down('md')} {
    height: 470px;
  }

  @keyframes header-animate-1 {
    0% {
      opacity: 0;
    }
    50% {
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes header-animate-2 {
    0% {
      transform: translateX(205px);
      opacity: 0;
    }
    50% {
    }
    100% {
      opacity: 1;
      transform: translateX(180px);
    }
  }

  @keyframes header-animate-3 {
    0% {
      transform: translateX(385px);
      opacity: 0;
    }
    50% {
    }
    100% {
      opacity: 1;
      transform: translateX(360px);
    }
  }
`;

export const AnimatedImage1 = styled(Box)`
  position: absolute;
  width: 300px;
  animation: header-animate-1 1s linear;
  animation-fill-mode: forwards;
  opacity: 0;
  filter: drop-shadow(2px 4px 6px #999999);
`;

export const AnimatedImage2 = styled(Box)`
  position: absolute;
  top: 50px;
  animation: header-animate-2 1s linear;
  animation-delay: 2s;
  animation-fill-mode: forwards;
  transform: translateX(180px);
  width: 300px;
  opacity: 0;
  filter: drop-shadow(2px 4px 6px #999999);
`;

export const AnimatedImage3 = styled(Box)`
  position: absolute;
  top: 100px;
  animation: header-animate-3 1s linear;
  animation-delay: 5s;
  animation-fill-mode: forwards;
  transform: translateX(360px);
  width: 300px;
  opacity: 0;
  filter: drop-shadow(2px 4px 6px #999999);
`;

// Content Section
export const ContentSection = styled(Box)`
  width: 100%;
  max-width: ${props => props.theme.breakpoints.values.lg}px;
  padding: 0 ${props => props.theme.spacing(3)};
  margin-top: ${props => props.theme.spacing(8)} !important;

  ${props => props.theme.breakpoints.down('md')} {
    border-top: 1px dashed ${props => props.theme.palette.grey[300]};
    margin-top: ${props => props.theme.spacing(4)} !important;
    padding-top: ${props => props.theme.spacing(4)} !important;
  }
`;

export const ContentFullBar = styled(Box)`
  width: 100%;
  margin-top: ${props => props.theme.spacing(8)} !important;
  background-color: ${props => props.theme.palette.primary.main};
  color: #fff;
  padding: ${props => props.theme.spacing(6)} 0;
  justify-content: center;
  display: flex;
`;

export const ContentFullBarInfo = styled(Grid)`
  max-width: ${props => props.theme.breakpoints.values.lg}px;
  display: flex;
  justify-content: center;
  text-align: center;

  & .MuiButtonBase-root {
    border: 1px solid #fff;
  }
`;

export const DividerTemp = styled(Box)`
  width: 100%;
  border-top: 1px dashed #ccc;
`;

export const StyledAppCard = styled(AppCard)`
  border-radius: 5px;
  padding: 24px;
  box-shadow: 0 0 10px 1px #ddd;
  overflow: hidden;

  &.noPadding {
    padding: 0;
  }
`;

export const HighlightedTitle = styled(Typography)`
  font-size: 16px !important;
  font-weight: 500 !important;
  border-left: 2px solid ${props => props.theme.palette.secondary.main};
  padding-left: ${props => props.theme.spacing(1)};
  margin-left: -${props => props.theme.spacing(1.25)};
`;

export const StyledBulletList = styled.ul`
  list-style: none;
  padding: 0px;
  display: flex;
  flex-wrap: wrap;

  & li {
    margin: 4px 0px;
    width: 100%;

    &:before {
      font-family: 'Material Icons';
      content: 'check';
      font-weight: bold;
      background-color: #fafafa;
      color: #148ecc;
      border-radius: 5px;
      font-size: 16px;
      margin-right: 8px;
      height: 18px;
      width: 18px;
      text-align: center;
      padding: 4px;
    }
  }
  &.width50 {
    & li {
      width: 50%;

      ${props => props.theme.breakpoints.down('md')} {
        width: 100%;
      }
    }
  }
`;

export const UserTestimonial = styled(Box)`
  display: flex;
  align-items: center;

  & img {
    margin-right: ${props => props.theme.spacing(2)};
    height: 48px;
    border-radius: 50%;
    border: 1px solid #ccc;
  }
`;

export const MembershipPricingDetails = styled(Grid)`
  border-top: 1px solid ${props => props.theme.palette.grey[300]};
  background-color: ${props => props.theme.palette.grey[50]};
  text-align: center;
  padding-top: ${props => props.theme.spacing(2)};
  padding-bottom: ${props => props.theme.spacing(3)};

  & > *:not(:first-child) {
    border-left: 1px solid ${props => props.theme.palette.grey[300]};
  }
`;
